// import React, { useState } from "react";
// import Highcharts from "highcharts";
// import HighchartsReact from "highcharts-react-official";
// import Variwide from "highcharts/modules/variwide";

// // Initialize the variwide module
// Variwide(Highcharts);

// const DrugProceduresChart = () => {
//   const rawData = [
//     ["COVID-19 Infusion Therapy", 1.45, 50.0],
//     ["Contrast Agents/Diagnostic Imaging", 0.0, 100],
//     ["Additional Miscellaneous Drugs", 5.41, 100],
//     ["Chemotherapy Anti-emetic Medications", 39.78, 50.0],
//     ["Miscellaneous Drugs and Tests", 0.0, 100],
//     ["Skin Substitutes and Biologicals", 3.73, 100],
//     ["Cancer, Vision and Other Associated Drugs", 4.88, 100],
//     ["Other Drugs and Test", 10.58, 99.79],
//   ];

//   const [filter1, setFilter1] = useState("Option A");
//   const [filter2, setFilter2] = useState("Option X");
//   const [filter3, setFilter3] = useState("2024");
//   // const rawData = [
//   //   ["Surgical Procedures on the Integumentary System", 333.13, 142.33],
//   //   ["Surgical Procedures on the Integumentary System", 333.13, 140.33],
//   //   ["Surgical Procedures on the Endocrine System", 6.47, 166.81],
//   //   ["Surgical Procedures on the Endocrine System", 6.47, 168.8],
//   //   ["Preventive Medicine Services", 292.62, 120.01],
//   //   ["Ophthalmology Services and Procedures", 277.79, 132.62],
//   //   ["Neurology and Neuromuscular Procedures", 127.73, 157.29],
//   //   ["Surgical Procedures on the Endocrine System", 6.47, 167.41],
//   //   ["Ophthalmology Services and Procedures", 277.79, 127.73],
//   //   ["Ophthalmology Services and Procedures", 277.79, 132.8],
//   //   ["Surgical Procedures on the Integumentary System", 333.13, 140.44],
//   //   ["Surgical Procedures on the Endocrine System", 6.47, 168.35],
//   //   ["Preventive Medicine Services", 292.62, 120.84],
//   //   ["Skin Substitutes and Biologicals", 10.59, 110.71],
//   //   ["Neurology and Neuromuscular Procedures", 127.73, 154.89],
//   //   ["Surgical Procedures on the Integumentary System", 333.13, 142.52],
//   //   ["Preventive Medicine Services", 292.62, 86.76],
//   //   ["Preventive Medicine Services", 292.62, 120.9],
//   //   ["Surgical Procedures on the Endocrine System", 6.47, 169.63],
//   //   ["Surgical Procedures on the Integumentary System", 333.13, 143.3],
//   //   ["Preventive Medicine Services", 292.62, 121.76],
//   //   ["Preventive Medicine Services", 292.62, 120.95],
//   //   ["Surgical Procedures on the Integumentary System", 333.13, 144.96],
//   //   ["Surgical Procedures on the Integumentary System", 333.13, 142.72],
//   //   ["Skin Substitutes and Biologicals", 10.59, 110.71],
//   //   ["Preventive Medicine Services", 292.62, 121.0],
//   //   ["Surgical Procedures on the Endocrine System", 6.47, 168.36],
//   //   ["Surgical Procedures on the Integumentary System", 333.13, 142.75],
//   //   ["Skin Substitutes and Biologicals", 10.59, 110.99],
//   //   ["Preventive Medicine Services", 292.62, 121.73],
//   //   ["Vaccines, Toxoids", 67.12, 105.89],
//   //   ["Preventive Medicine Services", 292.62, 120.15],
//   //   ["Psychiatry Services and Procedures", 323.27, 109.94],
//   //   ["Preventive Medicine Services", 292.62, 119.85],
//   //   ["Surgical Procedures on the Integumentary System", 333.13, 142.52],
//   //   ["Surgical Procedures on the Integumentary System", 333.13, 141.83],
//   //   ["Vaccines, Toxoids", 67.12, 105.88],
//   //   ["Surgical Procedures on the Endocrine System", 6.47, 168.91],
//   //   ["Preventive Medicine Services", 292.62, 121.29],
//   //   ["Preventive Medicine Services", 292.62, 120.89],
//   //   ["Skin Substitutes and Biologicals", 10.59, 110.82],
//   //   ["Skin Substitutes and Biologicals", 10.59, 110.71],
//   //   ["Preventive Medicine Services", 292.62, 190.99],
//   //   ["Surgical Procedures on the Integumentary System", 333.13, 141.82],
//   //   ["Surgical Procedures on the Endocrine System", 6.47, 167.82],
//   //   ["Surgical Procedures on the Endocrine System", 6.47, 168.38],
//   //   ["Neurology and Neuromuscular Procedures", 127.73, 157.22],
//   //   ["Preventive Medicine Services", 292.62, 120.84],
//   //   ["Surgical Procedures on the Integumentary System", 333.13, 143.0],
//   //   ["Skin Substitutes and Biologicals", 10.59, 110.71],
//   //   ["Neurology and Neuromuscular Procedures", 127.73, 157.22],
//   //   ["Preventive Medicine Services", 292.62, 96.41],
//   //   ["Ophthalmology Services and Procedures", 277.79, 132.8],
//   //   ["Surgical Procedures on the Endocrine System", 6.47, 168.92],
//   //   ["Neurology and Neuromuscular Procedures", 127.73, 156.95],
//   //   ["Ophthalmology Services and Procedures", 277.79, 132.69],
//   //   ["Neurology and Neuromuscular Procedures", 127.73, 156.92],
//   //   ["Surgical Procedures on the Endocrine System", 6.47, 167.84],
//   //   ["Vaccines, Toxoids", 67.12, 134.97],
//   //   ["Ophthalmology Services and Procedures", 277.79, 132.62],
//   //   ["Surgical Procedures on the Endocrine System", 6.47, 168.35],
//   //   ["Ophthalmology Services and Procedures", 277.79, 132.11],
//   //   ["Ophthalmology Services and Procedures", 277.79, 132.62],
//   //   ["General Surgical Procedures", 4.12, 101.47],
//   //   ["Acupuncture Procedures", 50.39, 134.92],
//   //   ["Newborn Care Services", 9.88, 118.13],
//   //   ["Ophthalmology Services and Procedures", 277.79, 133.68],
//   //   [
//   //     "Central Nervous System Assessments/Tests (eg, Neuro-Cognitive, Mental Status, Speech Testing)",
//   //     48.24,
//   //     131.32,
//   //   ],
//   //   ["Acupuncture Procedures", 50.39, 104.78],
//   //   ["Breast, Mammography", 140.65, 171.4],
//   //   ["Other Medicine Services and Procedures", 13.44, 157.23],
//   //   ["Care Management Services", 31.95, 83.96],
//   //   ["Psychiatry Services and Procedures", 323.27, 109.92],
//   //   ["Breast, Mammography", 140.65, 170.53],
//   //   ["Office or Other Outpatient Services", 3018.99, 109.17],
//   //   ["Care Management Services", 31.95, 97.84],
//   //   ["Miscellaneous Services", 24.26, 137.36],
//   //   ["Acupuncture Procedures", 50.39, 104.79],
//   //   ["Psychiatry Services and Procedures", 323.27, 166.99],
//   //   ["Diagnostic Radiology (Diagnostic Imaging) Procedures", 483.51, 215.25],
//   //   ["Nursing Facility Services", 0.42, 91.21],
//   //   ["Acupuncture Procedures", 50.39, 167.77],
//   //   ["Office or Other Outpatient Services", 3018.99, 106.52],
//   //   ["Diagnostic Radiology (Diagnostic Imaging) Procedures", 483.51, 214.41],
//   // ];

//   // const transformedData = rawData.map(([name, width, height]) => [
//   //   name,
//   //   height,
//   //   width,
//   // ]);

//   // Width normalization function
//   const getNormalizedWidth = (weight) => {
//     if (weight <= 0) return 0.1;
//     if (weight > 0 && weight <= 1) return 0.5;

//     if (weight > 1 && weight <= 10) return 2;
//     if (weight > 10 && weight <= 20) return 3;
//     if (weight > 20 && weight <= 30) return 4;
//     if (weight > 30 && weight <= 40) return 5;
//     if (weight > 40 && weight <= 50) return 6;
//     if (weight > 50 && weight <= 60) return 7;
//     if (weight > 60 && weight <= 70) return 8;
//     if (weight > 70 && weight <= 80) return 9;
//     if (weight > 80 && weight <= 90) return 10;
//     if (weight > 90 && weight <= 100) return 11;
//     return 12;
//   };

//   // Transform raw data
//   const transformedData = rawData.map(([name, weight, cost]) => ({
//     name,
//     y: cost,
//     z: getNormalizedWidth(weight), // use normalized weight for width
//     realWeight: weight, // store original for tooltip
//   }));

//   const colorPalette = [
//     "#c0e7e7",
//     "#507a8a",
//     "#d1e8ff",
//     "#ffd29f",
//     "#f7bf9e",
//     "#f7e6da",
//     "#f4e7bb",
//     "#c2e2ea",
//     "#d7e3fc ",
//   ];

//   const options = {
//     chart: {
//       type: "variwide",
//     },
//     colors: colorPalette, // <-- Add this line
//     title: {
//       text: "%completeness and Medicare Weight",
//     },
//     subtitle: {
//       text: "Variation of Width Range",
//     },
//     xAxis: {
//       type: "category",
//       labels: {
//         rotation: 0,
//         style: {
//           fontFamily: "'Roboto Flex', serif !important",
//           fontSize: "12px",
//           whiteSpace: "nowrap",
//           textOverflow: "ellipsis",
//           fontSize: "12px",
//           width: "100px",
//         },
//       },
//     },

//     credits: { enabled: false },
//     plotOptions: {
//       variwide: {
//         dataLabels: {
//           enabled: true,
//         },
//       },

//       series: {
//         states: {
//           hover: {
//             enabled: false,
//           },
//         },
//       },
//     },
//     // caption: {
//     //   text: "Column widths are proportional to value (Z)",
//     // },
//     legend: {
//       enabled: false,
//     },

//     series: [
//       {
//         name: "Cost",
//         data: transformedData,

//         tooltip: {
//           pointFormat:
//             "% Completeness: <b>{point.y}</b><br>Medicare Weight: <b>{point.realWeight}</b>",
//         },
//         borderRadius: 3,
//         colorByPoint: true,
//       },
//     ],
//   };

//   return (
//     <div style={{ backgroundColor: "white", padding: "10px  " }}>
//       <div
//         style={{
//           marginBottom: "1rem",
//           display: "flex",
//           gap: "1rem",
//           backgroundColor: "white",
//           padding: "10px",
//           borderRadius: "6px",
//         }}
//       >
//         <div className="d-flex flex-column">
//           <label className="form-label">Select Network:</label>
//           <select
//             value={filter1}
//             onChange={(e) => setFilter1(e.target.value)}
//             style={{
//               width: "180px",
//               backgroundColor: "white",
//               padding: "10px",
//               border: "1px solid #ccc",
//               borderRadius: "6px",
//             }}
//           >
//             <option>Select Network</option>
//           </select>
//         </div>
//         <div className="d-flex flex-column">
//           <label className="form-label">Select Category:</label>
//           <select
//             value={filter2}
//             onChange={(e) => setFilter2(e.target.value)}
//             style={{
//               width: "180px",
//               backgroundColor: "white",
//               padding: "10px",
//               border: "1px solid #ccc",
//               borderRadius: "6px",
//             }}
//           >
//             <option>Select Category</option>
//           </select>
//         </div>
//         <div className="d-flex flex-column">
//           <label className="form-label">Select Metrics:</label>
//           <select
//             value={filter3}
//             onChange={(e) => setFilter3(e.target.value)}
//             style={{
//               width: "180px",
//               backgroundColor: "white",
//               padding: "10px",
//               border: "1px solid #ccc",
//               borderRadius: "6px",
//             }}
//           >
//             <option>Select Metrics</option>
//           </select>
//         </div>
//       </div>
//       <HighchartsReact highcharts={Highcharts} options={options} />
//     </div>
//   );
// };

// export default DrugProceduresChart;

import React, { useState } from "react";
import Highcharts, { color } from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Variwide from "highcharts/modules/variwide";

Variwide(Highcharts);

// Sample nested data structure
const data = {
  "Cigna Carelink": {
    "Category III Codes": {
      "Procedures performed on Cornea": {
        "Medicare Weight": 1.0,
        "% Medicare": 84.77,
        "% Discount": -12.65056361,
        "% Completeness": 100.0,
      },
      "Wound Imaging for Bacterial Presence": {
        "Medicare Weight": 1.0,
        "% Medicare": 231.33,
        "% Discount": -36.25120773,
        "% Completeness": 100.0,
      },
      "Laser Ablation Procedures": {
        "Medicare Weight": 1.0,
        "% Medicare": 99.975,
        "% Discount": -15.09903382,
        "% Completeness": 100.0,
      },
      "Cardiac Rhythm Monitor System Evaluation": {
        "Medicare Weight": 1.0,
        "% Medicare": 536.43,
        "% Discount": -85.38164251,
        "% Completeness": 100.0,
      },
      "Procedures Performed on Prostate": {
        "Medicare Weight": 1.24,
        "% Medicare": 124.21,
        "% Discount": -19.00161031,
        "% Completeness": 100.0,
      },
      "Trabeculostomy Procedure by Laser (Ab Interno)": {
        "Medicare Weight": 1.98,
        "% Medicare": 146.83,
        "% Discount": -22.64412238,
        "% Completeness": 100.0,
      },
      "Ocular Telescope Prosthesis Insertion Procedure": {
        "Medicare Weight": 1.0,
        "% Medicare": 83.78,
        "% Discount": -12.49114332,
        "% Completeness": 100.0,
      },
      "Insertion of Aqueous Drainage Device": {
        "Medicare Weight": 1.0,
        "% Medicare": 102.5604167,
        "% Discount": -15.515365,
        "% Completeness": 100.0,
      },
      "Quantitative Ultrasound Tissue Characterization": {
        "Medicare Weight": 1.0,
        "% Medicare": 233.15,
        "% Discount": -36.54428341,
        "% Completeness": 100.0,
      },
      "Vision Studies, Implants and Therapies": {
        "Medicare Weight": 1.0,
        "% Medicare": 161.16,
        "% Discount": -24.95169082,
        "% Completeness": 100.0,
      },
      "High Dose Rate Electronic Brachytherapy Procedures": {
        "Medicare Weight": 2.0,
        "% Medicare": 204.925,
        "% Discount": -31.99919485,
        "% Completeness": 100.0,
      },
      "Subchondral Bone Defect Injection Procedure": {
        "Medicare Weight": 3.06,
        "% Medicare": 145.6223571,
        "% Discount": -22.44965493,
        "% Completeness": 100.0,
      },
      "Percutaneous Cryoablation Procedures": {
        "Medicare Weight": 5.06,
        "% Medicare": 114.3475,
        "% Discount": -17.41344605,
        "% Completeness": 80.23715415,
      },
      "Various Services - Category III Codes": {
        "Medicare Weight": 59.25,
        "% Medicare": 101.939674,
        "% Discount": -15.41540644,
        "% Completeness": 66.17721519,
      },
      "Imaging, Testing, Implantation and Other Services": {
        "Medicare Weight": 41.52,
        "% Medicare": 98.19850845,
        "% Discount": -14.81296432,
        "% Completeness": 61.46435453,
      },
      "Carotid Sinus Baroreflex Activation Device Procedures": {
        "Medicare Weight": 12.42,
        "% Medicare": 85.70129283,
        "% Discount": -12.80053025,
        "% Completeness": 51.69082126,
      },
      "Permanent Cardiac Contractility Modulation System Procedures": {
        "Medicare Weight": 23.15,
        "% Medicare": 94.69638674,
        "% Discount": -14.24901558,
        "% Completeness": 50.1511879,
      },
      "Neurofibroma Destruction Procedure": {
        "Medicare Weight": 2.0,
        "% Medicare": 249.04,
        "% Discount": -39.10305958,
        "% Completeness": 50.0,
      },
      "Tissue Characterization by Quantitative CT": {
        "Medicare Weight": 2.0,
        "% Medicare": 395.95,
        "% Discount": -62.76006441,
        "% Completeness": 50.0,
      },
      "Percutaneous Lumbar Intravertebral Disc Injection Procedure": {
        "Medicare Weight": 90.18,
        "% Medicare": 111.0541304,
        "% Discount": -16.88311279,
        "% Completeness": 50.0,
      },
      "Percutaneous Decompressive Laminotomy/Laminectomy Procedures through Interlaminar Approach":
        {
          "Medicare Weight": 21.46,
          "% Medicare": 113.2967164,
          "% Discount": -17.24423775,
          "% Completeness": 50.0,
        },
      "Quantitative Magnetic ResoUnavailablece Tissue Composition Analysis": {
        "Medicare Weight": null,
        "% Medicare": 679.82,
        "% Discount": -108.4718196,
        "% Completeness": 50.0,
      },
      "Atherectomy (Open or Percutaneous) for Supra-Inguinal Arteries": {
        "Medicare Weight": 42.97,
        "% Medicare": 106.4828352,
        "% Discount": -16.14699439,
        "% Completeness": 43.91435886,
      },
      "Insertion and Removal of Implantable Interstitial Glucose Sensor": {
        "Medicare Weight": 3.0,
        "% Medicare": 105.87,
        "% Discount": -16.04830918,
        "% Completeness": 33.33333333,
      },
      "Neurostimulation Procedures": {
        "Medicare Weight": 4.0,
        "% Medicare": 117.695,
        "% Discount": -17.95249597,
        "% Completeness": 25.0,
      },
    },
    "Miscellaneous Medical Services": {
      "Miscellaneous Medical Services": {
        "Medicare Weight": 16.0,
        "% Medicare": 166.2419643,
        "% Discount": -25.77004256,
        "% Completeness": 25.0,
      },
    },
  },
  "Cigna Arizona HMO": {
    "Category III Codes": {
      "Subchondral Bone Defect Injection Procedure": {
        "Medicare Weight": 3.06,
        "% Medicare": 95.59,
        "% Discount": -14.39291465,
        "% Completeness": 100.0,
      },
      "Insertion of Aqueous Drainage Device": {
        "Medicare Weight": 1.0,
        "% Medicare": 78.24,
        "% Discount": -11.59903382,
        "% Completeness": 100.0,
      },
      "Percutaneous Lumbar Intravertebral Disc Injection Procedure": {
        "Medicare Weight": 90.18,
        "% Medicare": 144.03,
        "% Discount": -22.19323671,
        "% Completeness": 50.0,
      },
      "Percutaneous Decompressive Laminotomy/Laminectomy Procedures through Interlaminar Approach":
        {
          "Medicare Weight": 21.46,
          "% Medicare": 120.319,
          "% Discount": -18.37504026,
          "% Completeness": 50.0,
        },
      "Permanent Cardiac Contractility Modulation System Procedures": {
        "Medicare Weight": 23.15,
        "% Medicare": 85.38716305,
        "% Discount": -12.74994574,
        "% Completeness": 45.83153348,
      },
      "Carotid Sinus Baroreflex Activation Device Procedures": {
        "Medicare Weight": 12.42,
        "% Medicare": 87.065,
        "% Discount": -13.02012882,
        "% Completeness": 43.63929147,
      },
      "Atherectomy (Open or Percutaneous) for Supra-Inguinal Arteries": {
        "Medicare Weight": 42.97,
        "% Medicare": 91.21,
        "% Discount": -13.68760064,
        "% Completeness": 15.87153828,
      },
    },
  },
  "Cigna Central Florida": {
    "Category III Codes": {
      "Subchondral Bone Defect Injection Procedure": {
        "Medicare Weight": 3.06,
        "% Medicare": 102.7025,
        "% Discount": -15.53824477,
        "% Completeness": 100.0,
      },
      "Insertion of Aqueous Drainage Device": {
        "Medicare Weight": 1.0,
        "% Medicare": 70.12,
        "% Discount": -10.29146538,
        "% Completeness": 100.0,
      },
      "Percutaneous Lumbar Intravertebral Disc Injection Procedure": {
        "Medicare Weight": 90.18,
        "% Medicare": 113.895,
        "% Discount": -17.34057971,
        "% Completeness": 50.0,
      },
      "Percutaneous Decompressive Laminotomy/Laminectomy Procedures through Interlaminar Approach":
        {
          "Medicare Weight": 21.46,
          "% Medicare": 82.4625,
          "% Discount": -12.27898551,
          "% Completeness": 50.0,
        },
      "Percutaneous Cryoablation Procedures": {
        "Medicare Weight": 5.06,
        "% Medicare": 149.27,
        "% Discount": -23.03703704,
        "% Completeness": 40.11857708,
      },
      "Atherectomy (Open or Percutaneous) for Supra-Inguinal Arteries": {
        "Medicare Weight": 42.97,
        "% Medicare": 90.34,
        "% Discount": -13.54750403,
        "% Completeness": 28.04282057,
      },
      "Various Services - Category III Codes": {
        "Medicare Weight": 59.25,
        "% Medicare": 604.318,
        "% Discount": -96.3136876,
        "% Completeness": 1.687763713,
      },
    },
  },
};
const colorPalette = [
  "#c0e7e7",
  "#507a8a",
  "#d1e8ff",
  "#ffd29f",
  "#f7bf9e",
  "#f7e6da",
  "#f4e7bb",
  "#c2e2ea",
  "#d7e3fc ",
  "#F8D7DD",
  "#F7C6B5",
  "#D7FBFB",
];

const DrugProceduresChart = () => {
  const networks = Object.keys(data);
  const categories = networks.length > 0 ? Object.keys(data[networks[0]]) : [];
  const metrics = ["% Completeness", "% Medicare", "% Discount"];
  const [selectedNetwork, setSelectedNetwork] = useState(networks[0]);
  const [selectedCategory, setSelectedCategory] = useState(categories[0]);
  const [selectedMetric, setSelectedMetric] = useState(metrics[0]);
  const procedures = data[selectedNetwork]?.[selectedCategory] ?? {};
  const transformedData = Object.entries(procedures).map(([name, values]) => ({
    name,
    y: values[selectedMetric],
    z: normalizeWeight(values["Medicare Weight"]),
    realWeight: values["Medicare Weight"],
  }));
  const [expanded, setExpanded] = useState(false);
  const maxVisibleItems = 7;

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  const visibleItems = expanded
    ? transformedData
    : transformedData.slice(0, maxVisibleItems);

  function normalizeWeight(weight) {
    if (weight <= 0) return 0.1;
    if (weight <= 1) return 0.5;
    if (weight <= 10) return 2;
    if (weight <= 20) return 3;
    if (weight <= 30) return 4;
    if (weight <= 40) return 5;
    if (weight <= 50) return 6;
    if (weight <= 60) return 7;
    if (weight <= 70) return 8;
    if (weight <= 80) return 9;
    if (weight <= 90) return 10;
    if (weight <= 100) return 11;
    return 12;
  }

  const chartOptions = {
    chart: {
      type: "variwide",
    },
    colors: colorPalette,
    title: {
      text: `${selectedMetric} and Medicare Weight`,
    },
    xAxis: {
      type: "category",
      labels: {
        enabled: false,
        // rotation: 0,
        // style: { fontSize: "12px", whiteSpace: "nowrap" },
      },
    },
    credits: { enabled: false },
    legend: { enabled: false },
    plotOptions: {
      variwide: {
        dataLabels: {
          enabled: true,
        },
      },
    },
    plotOptions: {
      variwide: {
        dataLabels: {
          enabled: false,
        },
      },

      series: {
        states: {
          hover: {
            enabled: false,
          },
        },
      },
    },
    series: [
      {
        name: selectedMetric,
        data: transformedData,
        tooltip: {
          pointFormat: `${selectedMetric}: <b>{point.y}</b><br>Medicare Weight: <b>{point.realWeight}</b>`,
        },
        colorByPoint: true,
        borderRadius: 3,
      },
    ],
  };

  return (
    <div
      className="bg-white p-4 "
      style={{ border: "none", borderRadius: "8px", margin: "0px 20px" }}
    >
      {/* <div style={{ marginBottom: "1rem", display: "flex", gap: "1rem" }}>
        <select
          value={selectedNetwork}
          onChange={(e) => setSelectedNetwork(e.target.value)}
        >
          {networks.map((net) => (
            <option key={net}>{net}</option>
          ))}
        </select>
        <select
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
        >
          {Object.keys(data[selectedNetwork]).map((cat) => (
            <option key={cat}>{cat}</option>
          ))}
        </select>
        <select
          value={selectedMetric}
          onChange={(e) => setSelectedMetric(e.target.value)}
        >
          {metrics.map((m) => (
            <option key={m}>{m}</option>
          ))}
        </select>
      </div> */}

      {/* <div className="mb-3 d-flex gap-3">
        <select
          className="form-select"
          value={selectedNetwork}
          variant="primary"
          id="dropdown-basic"
          onChange={(e) => setSelectedNetwork(e.target.value)}
        >
          {networks.map((net) => (
            <option key={net}>{net}</option>
          ))}
        </select>

        <select
          className="form-select"
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
        >
          {Object.keys(data[selectedNetwork]).map((cat) => (
            <option key={cat}>{cat}</option>
          ))}
        </select>

        <select
          className="form-select"
          value={selectedMetric}
          onChange={(e) => setSelectedMetric(e.target.value)}
        >
          {metrics.map((m) => (
            <option key={m}>{m}</option>
          ))}
        </select>
      </div> */}

      <div className="mb-4 d-flex flex-row justify-content-start align-items-center gap-2">
        {/* Network Dropdown */}
        <label className="form-label mb-0">Network:</label>
        <div className="dropdown">
          <a
            className="btn btn-secondary dropdown-toggle p-2"
            href="#"
            variant="primary"
            id="dropdown-basic"
            role="button"
            // id="networkDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {selectedNetwork || "Select Network"}
          </a>
          <ul className="dropdown-menu" aria-labelledby="networkDropdown">
            {networks.map((net) => (
              <li key={net}>
                <a
                  className="dropdown-item"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setSelectedNetwork(net);
                  }}
                >
                  {net}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Category Dropdown */}
        <label className="form-label mb-0">Category:</label>
        <div className="dropdown">
          <a
            className="btn btn-secondary dropdown-toggle p-2"
            href="#"
            role="button"
            variant="primary"
            id="dropdown-basic"
            // id="categoryDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {selectedCategory || "Select Category"}
          </a>
          <ul className="dropdown-menu" aria-labelledby="categoryDropdown">
            {Object.keys(data[selectedNetwork] || {}).map((cat) => (
              <li key={cat}>
                <a
                  className="dropdown-item"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setSelectedCategory(cat);
                  }}
                >
                  {cat}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* Metric Dropdown */}
        <label className="form-label mb-0">Metric:</label>
        <div className="dropdown">
          <a
            className="btn btn-secondary dropdown-toggle p-2"
            href="#"
            role="button"
            variant="primary"
            id="dropdown-basic"
            // id="metricDropdown"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {selectedMetric || "Select Metric"}
          </a>
          <ul className="dropdown-menu" aria-labelledby="metricDropdown">
            {metrics.map((m) => (
              <li key={m}>
                <a
                  className="dropdown-item"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setSelectedMetric(m);
                  }}
                >
                  {m}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <HighchartsReact highcharts={Highcharts} options={chartOptions} />
      {/* <div style={{ marginBottom: "1rem" }}>
        <ul
          style={{
            listStyle: "none",
            padding: 0,
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            justifyContent: "center",
          }}
        >
          {transformedData.map((item, index) => (
            <li
              key={index}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                fontSize: "14px",
                fontFamily: "Roboto, sans-serif",
              }}
            >
              <span
                style={{
                  width: "12px",
                  height: "12px",
                  backgroundColor: colorPalette[index % colorPalette.length],
                  display: "inline-block",
                  borderRadius: "2px",
                }}
              />
              {item.name}
            </li>
          ))}
        </ul>
      </div> */}
      <div style={{ marginBottom: "1rem" }}>
        <ul
          style={{
            listStyle: "none",
            padding: 0,
            display: "flex",
            flexWrap: "wrap",
            gap: "16px",
            justifyContent: "center",
          }}
        >
          {visibleItems.map((item, index) => (
            <li
              key={index}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                fontSize: "14px",
                fontFamily: "Roboto, sans-serif",
              }}
            >
              <span
                style={{
                  width: "16px",
                  height: "16px",
                  backgroundColor: colorPalette[index % colorPalette.length],
                  display: "inline-block",
                  borderRadius: "4px",
                }}
              />
              {item.name}
            </li>
          ))}

          {transformedData.length > maxVisibleItems && (
            <li
              onClick={toggleExpanded}
              style={{
                cursor: "pointer",
                fontSize: "14px",
                fontFamily: "Roboto, sans-serif",
                color: "#007bff",
                textDecoration: "underline",
              }}
            >
              {expanded ? "See less" : "See more"}
            </li>
          )}
        </ul>
      </div>
    </div>
  );
};

export default DrugProceduresChart;
